<div class="AMAlertPremierDisclaimer bg-purple-premier text-am-white">
  <div class="AMAlertPremierDisclaimer_container d-flex align-items-center flex-column justify-content-center ">
    <button
      class="AMAlertPremierDisclaimer_close text-am-white"
      (click)="onClose()">
      <i class="far fa-times-circle fs-64px fw-lighter"></i>
    </button>
    <div class="AMAlertPremierDisclaimer_image d-flex position-relative bg-white">
      <img class="" src="./assets/images/menuPassenger_bagSelection.png" alt="Bags">
      <img class="" src="./assets/images/bags/premierPlusAdd.svg" alt="plus">
    </div>
    <p class="fs-52px text-center mt-2">
      {{ title | translate }}
    </p>
    <p class="AMAlertPremierDisclaimer_text fs-32px text-center" *ngIf="!options.buyMoreBags">
      {{ subtitle | translate }}
    </p>
    <div class="AMAlertPremierDisclaimer-banner mb-4" *ngIf="options.buyMoreBags">
      <img alt="" src="./assets/images/crownIcon.png" />
      <span class="fs-20px">
        <p class="m-0">{{ 'modalConfirmPremierDisclaimer.subTitle' | translate }}</p>
      </span>
    </div>
    <div class="w-100">
      <button
        class="AMAlertPremierDisclaimer_button btn btn-light w-100"
        (click)="onClose()"
        *ngIf="!options.buyMoreBags"
      >
        {{ 'modalPremierDisclaimer.button' | translate}}
      </button>
      <div class="d-flex gap-3" *ngIf="options.buyMoreBags">
        <button class="AMAlertPremierDisclaimer_button btn btn-light w-100" (click)="onClose()">
          {{ 'modalConfirmPremierDisclaimer.no' | translate}}
        </button>
        <button class="AMAlertPremierDisclaimer_button btn btn-light w-100" (click)="onBuyBags()">
          {{ 'modalConfirmPremierDisclaimer.yes' | translate}}
        </button>
      </div>
    </div>
  </div>
  <div class="AMAlertPremierDisclaimer-totalBags" *ngIf="options.buyMoreBags">
    <div class="AMAlertPremierDisclaimer-textTotal">
      <img alt="" src="./assets/images/bagWhite.svg" />
      <span class="fs-24px">{{ 'modalConfirmPremierDisclaimer.total' | translate }}</span>
    </div>
    <div class="AMAlertPremierDisclaimer-counterBags fs-32px">
      <div [innerHTML]="'modalConfirmPremierDisclaimer.counter' | translate:{ counter: options.totalBags32 }"></div>
    </div>
  </div>
</div>
